import React, { ChangeEvent } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { concatString, isURL, refaCtoNullKey } from '../../../../../utils';
import { ReactComponent as Loader } from '../../../../../resources/images/Rolling.svg';

export type IpropsModal = {
  dataSource: any;
};
export default function ModalEditAboutOverview(props: IpropsModal) {
  return (
    <Modal
      show={props?.dataSource?.overviewShow}
      onHide={() => props?.dataSource?.setOverviewShow(false)}
      className='modalDevinsider large'
    >
      <Modal.Header closeButton>
        <Modal.Title>Company overview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='contentBorder row m-0 p-0'>
          <div className='col-12 descCompany'>
            <span>
              <b>Outline a brief of your company</b>
            </span>
            <textarea
              name=''
              value={refaCtoNullKey(
                props?.dataSource?.infoCompanyToEdit?.overview,
                ''
              )}
              onChange={(evt: ChangeEvent<HTMLTextAreaElement>) =>
                props?.dataSource?.setInfoCompanyToEdit({
                  ...props?.dataSource?.infoCompanyToEdit,
                  overview: evt.target.value,
                })
              }
              maxLength={450}
            />
            {props?.dataSource?.infoCompanyToEdit.overview != 'null' && (
              <div className='caractercount'>
                {`${
                  0 +
                  (props?.dataSource?.infoCompanyToEdit?.overview?.length || 0)
                } / 450`}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='cancelbtn'
          onClick={() => props?.dataSource?.cancelChange()}
        >
          Cancel
        </Button>
        <Button
          className='validate'
          onClick={() => props?.dataSource?.updateCompanyResellerDetails()}
          disabled={props?.dataSource?.isLoaderShow}
        >
          {props?.dataSource?.isLoaderShow ? <Loader /> : 'Save'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
